










































import type { Field, MergeValues } from '@getaccept/editor-lib';
import { Context } from '@getaccept/editor-lib';
import type { User } from '@getaccept/lib-shared/src/users/types/user';
import type { Recipient } from '@getaccept/lib-shared/src/types/Recipient';
import type { EditorRecipientInput } from '@getaccept/lib-shared/src/types/editor-recipient-input';
import type { PropType } from '@vue/composition-api';
import { computed, defineComponent } from '@vue/composition-api';
import { SigningHelper } from '@getaccept/lib-shared/src/signature/helpers/signing.helper';
import type { RecipientStatus } from '@getaccept/lib-shared/src/recipients/types/enums/recipient-status';
import { useInputFieldView } from '../composables/input-field-view.composable';
import InputSetLabel from './InputSetLabel.vue';
import InputSetField from './InputSetField.vue';

export default defineComponent({
  name: 'InputSet',
  components: {
    InputSetField,
    InputSetLabel,
  },
  props: {
    context: { type: String as PropType<Context>, default: () => Context.Document },
    failedInputUpdates: { type: Array as PropType<EditorRecipientInput[]>, default: () => [] },
    fields: { type: Array as PropType<Field[]>, default: () => [] },
    focusedRequiredId: { type: String, default: '' },
    inputSet: { type: Array as PropType<Field[]>, default: () => [] },
    isMobile: { type: Boolean },
    isPdfViewer: { type: Boolean },
    isSigningSite: { type: Boolean },
    mergeValues: { type: Object as PropType<MergeValues>, default: () => ({}) },
    recipient: { type: Object as PropType<Recipient>, default: () => ({}) },
    recipientInput: { type: Array as PropType<EditorRecipientInput[]>, required: true },
    sender: { type: Object as PropType<User>, default: () => ({}) },
    updatingInputs: { type: Array as PropType<EditorRecipientInput[]>, default: () => [] },
  },
  setup(props) {
    const { getIsAssignedToCurrentUser } = useInputFieldView(props);

    const hasRecipientSigned = computed(() => {
      return SigningHelper.hasRecipientSigned(
        (props.recipient as Recipient)?.status as RecipientStatus
      );
    });

    const hasFocus = (input: Field) => {
      if (!getIsAssignedToCurrentUser(input)) {
        return false;
      }
      return input.id === props.focusedRequiredId;
    };

    const getIsEditable = (input: Field) => {
      return (
        getIsAssignedToCurrentUser(input) &&
        !hasRecipientSigned.value &&
        props.context !== Context.DocumentView &&
        !props.isPdfViewer
      );
    };

    const getInputStyle = (input: Field) => {
      const width = props.isMobile ? 100 : input.inputSettings?.width || 100;
      return `width: ${width}%;`;
    };

    return {
      getInputStyle,
      getIsAssignedToCurrentUser,
      getIsEditable,
      hasFocus,
      hasRecipientSigned,
    };
  },
});
